
// Configuration for the application
import { useAuth } from '../users/AuthContext';

export const APP_URL = "https://api.dev.unik.ac.ug";
// export const APP_URL = "http://localhost:8000";

// Modern JWT Authentication headers using AuthContext
// Use this function within React components that have access to AuthContext
export const useJWTHeaders = () => {
    const { getAuthHeaders } = useAuth();
    return getAuthHeaders;
};

// Modern JWT FormData headers using AuthContext
// Use this function within React components that have access to AuthContext
export const useJWTFormDataHeaders = () => {
    const { getFormDataHeaders } = useAuth();
    return getFormDataHeaders;
};

// Modern authentication check using AuthContext
// Use this function within React components that have access to AuthContext
export const useUserAuthentication = () => {
    const { isAuthenticated } = useAuth();
    return isAuthenticated;
};

// Modern authenticated request function using AuthContext
// Use this function within React components that have access to AuthContext
// This function automatically handles token refresh and proper session management
export const useAuthenticatedRequest = () => {
    const { makeAuthenticatedRequest } = useAuth();
    return makeAuthenticatedRequest;
};

// Legacy functions (DEPRECATED - kept for backward compatibility)
// WARNING: These functions are deprecated and will be removed in a future version.
// Use the hook-based functions above or AuthContext directly instead.

export const getJWTHeaders = () => {
    console.warn('getJWTHeaders() is deprecated. Use useJWTHeaders() hook or AuthContext.getAuthHeaders() instead for automatic token refresh.');
    const token = localStorage.getItem('jwtToken');
    return {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
    };
};

export const getJWTFormDataHeaders = () => {
    console.warn('getJWTFormDataHeaders() is deprecated. Use useJWTFormDataHeaders() hook or AuthContext.getFormDataHeaders() instead for automatic token refresh.');
    const token = localStorage.getItem('jwtToken');
    return {
        'Authorization': `Bearer ${token}`
    };
};

export const isUserAuthenticated = () => {
    console.warn('isUserAuthenticated() is deprecated. Use useUserAuthentication() hook or AuthContext.isAuthenticated instead for proper session management.');
    return localStorage.getItem('jwtToken') !== null;
};